import styled from "@emotion/styled";

export const StyleOrderDetailContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.05),
    0 1px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid #f3f4f6;
  flex: 3;
`;

export const StyleOrderDetailTop = styled.div`
  margin-bottom: 16px;
`;

export const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px dashed #e5e7eb;
  margin: 16px 0;
`;

export const StyleText = styled.span`
  font-size: 14px;
  color: #374151;
`;
